module.exports = __webpack_public_path__ + "img/logo_inventory_amount.17f609c9.png";